<div class="container px-0">
  <div class="row">
    <div class="col"></div>
    <div class="col-auto">
      <button (click)="send()" *ngIf="message?.Payload?.AskToProceed" class="btn btn-dark btn-round" [innerHTML]="buttonText | bypassSecurityTrust : 'html'">
      </button>
    </div>
  </div>
</div>
